<template>
    <div>
        <v-dialog v-model="exibir" scrollable persistent :max-width="maxWidth">
            <v-card>
                <v-card-title class="primary modal-title py-0">
          <span>Solicitação de
            <span v-if="tipo==='ESCLARECIMENTO'">Esclarecimento</span>
            <span v-else>Impugnação</span>
          </span>
                    <v-spacer/>
                    <v-btn icon @click="fecharModal">
                        <v-icon size="20" color="white">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm2>
                            <div class="az-text">
                                <label class="label">Edital</label>
                                <div>{{ licitacao.numeroEdital }}</div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <div class="az-text pl-2" style="word-break: break-word;">
                                <label class="label">Objeto</label>
                                <div>{{ licitacao.objeto }}</div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm4 d-flex>
                            <div class="az-text">
                                <label class="label">Pessoa</label>
                                <div>
                                    <v-radio-group v-model="dadosGerais.tipoPessoa" row class="radio-group-esc-imp">
                                        <v-radio label="Jurídica" value="J"></v-radio>
                                        <v-radio label="Física" value="F"></v-radio>
                                    </v-radio-group>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 d-flex>
                            <div class="az-text pr-3">
                                <label v-if="ehPessoaFisica" class="label">Nome</label>
                                <v-text-field v-if="ehPessoaFisica"
                                              name="Nome" class="pt-0"
                                              placeholder="Informe o nome"
                                              v-model="dadosGerais.nomeRazaoSocial"
                                />
                                <label v-if="!ehPessoaFisica" class="label">Razão Social</label>
                                <v-text-field v-if="!ehPessoaFisica"
                                              name="Razão Social" class="pt-0"
                                              placeholder="Informe a razão social"
                                              v-model="dadosGerais.nomeRazaoSocial"
                                />
                            </div>
                        </v-flex>
                        <v-flex xs12 sm6 d-flex>
                            <div class="az-text">
                                <label v-show="ehPessoaFisica" class="label">CPF</label>
                                <v-text-field v-show="ehPessoaFisica" name="CPF" class="pt-0"
                                              v-mask="customMaskCPF" placeholder="Informe o CPF"
                                              v-model="dadosGerais.cpf"
                                />
                                <label v-show="!ehPessoaFisica" class="label">CNPJ</label>
                                <v-text-field v-show="!ehPessoaFisica" name="CNPJ" class="pt-0"
                                              v-mask="customMaskCNPJ" placeholder="Informe o CNPJ"
                                              v-model="dadosGerais.cnpj"
                                />
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 d-flex>
                            <div class="az-text pr-3">
                                <label class="label">E-mail</label>
                                <v-text-field name="E-mail" class="required-field pt-0"
                                              placeholder="Informe o e-mail"
                                              v-model="dadosGerais.email"
                                              v-validate="{required: true, email: true}"
                                              :error-messages="errors.collect('E-mail')"
                                ></v-text-field>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm6 md6 d-flex>
                            <div class="az-text">
                                <label class="label">Telefone</label>
                                <v-text-field name="Telefone" class="pt-0"
                                              placeholder="Informe o telefone"
                                              v-mask="customMaskTelefone"
                                              v-model="dadosGerais.telefone"
                                />
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12 d-flex>
                            <div class="az-text">
                                <label v-show="tipo === 'ESCLARECIMENTO'" class="label">Assunto Esclarecimento</label>
                                <label v-show="tipo === 'IMPUGNACAO'" class="label">Assunto Impugnação</label>
                                <v-textarea name="Assunto" class="pt-0"
                                            placeholder="Informe o assunto" rows="2"
                                            v-model="dadosGerais.assunto"
                                />
                            </div>
                        </v-flex>
                    </v-layout>
                    <div>
                        <p class="text-campo" style="margin-bottom: 5px">Anexo </p>
                        <licitacao-esclarecimento-anexo style="margin-top: -20px" tipo="pregoeiro"
                                                        @uploadArquivo="setarArquivoUpload"
                                                        @removerArquivoUpload="removerArquivoUpload"
                                                        />
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-layout class="justify-space-between">
                        <v-btn class="ml-2 mb-2" @click="fecharModal">CANCELAR</v-btn>
                        <v-btn class="mr-2 mb-2 primary"
                               @click="abrirModalConfirmarEnvio">
                            SOLICITAR
                        </v-btn>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <modal-confirmar-etapa-anexo
            v-model="modalConfirmarEnvio"
            :title="'Confirmar Envio'"
            :max-width="'450'"
            :text="mensagemConfirmacao"
            second-text="Esta ação NÃO PODERÁ ser desfeita!"
            @fecharModalConfirm="fecharModalConfirmarEnvio"
            @cancelarAcao="fecharModalConfirmarEnvio"
            @confirmarAcao="solicitar"
        />
    </div>
</template>
<script>
import {mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/commons/constants'
import ModalConfirmarEtapaAnexo from '@/commons/components/ModalConfirmarEtapaAnexo.vue'
import EdlFileUpload from '@/commons/components/file/EdlFileUpload.vue'
import LicitacaoEsclarecimentoAnexo from "@/views/licitacao/detalhe/commons/LicitacaoEsclarecimentoAnexo.vue";

export default {
    name: 'ModalCriarEsclarecimentoImpugnacaoServidor',
    components: {LicitacaoEsclarecimentoAnexo, EdlFileUpload, ModalConfirmarEtapaAnexo},
    props: {
        exibir: {
            type: Boolean,
            default: false
        },
        tipo: {
            type: String,
            default: 'ESCLARECIMENTO'
        },
        maxWidth: {
            type: String,
            default: '800'
        },
        licitacaoId: {
            type: Number
        }
    },
    data() {
        return {
            customMaskTelefone: {
                mask: '(##) #####-####',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            customMaskCNPJ: {
                mask: '##.###.###/####-##',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            customMaskCPF: {
                mask: '###.###.###-##',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            modalConfirmarEnvio: false,
            dadosGerais: {
                nomeRazaoSocial: null,
                cpf: null,
                cnpj: null,
                email: null,
                telefone: null,
                assunto: null,
                tipoPessoa: 'J',
                anexoUpload: null,
                repositorioUri: `repo1:licitacao/${this.licitacaoId}/${this.tipo}/inserir-manual`,
            }
        }
    },
    computed: {
        ...mapState(['loki', 'licitacao', 'parametros']),
        mensagemConfirmacao() {
            if (this.dadosGerais.anexoUpload) {
                const tipo = this.tipo === 'ESCLARECIMENTO' ? 'um esclarecimento' : 'uma impugnação'
                return `Atenção! Você está enviando ${tipo}. Deseja continuar?`
            } else {
                return 'Atenção, o anexo não foi inserido, deseja continuar?'
            }
        },
        ehPessoaFisica() {
            return this.dadosGerais.tipoPessoa === 'F'
        },
        arquivosAceitos() {
            return this.parametros.extensao
        }
    },
    methods: {
        async abrirModalConfirmarEnvio() {
            const estaValido = await this.validarCampos()
            if (!estaValido) {
                this.mostrarNotificacaoErro('Preencha os campos obrigatórios!')
            }
            if (estaValido) {
                this.modalConfirmarEnvio = true
            }
        },
        fecharModalConfirmarEnvio() {
            this.modalConfirmarEnvio = false
        },
        async solicitar() {
            const payload = {
                licitacaoId: this.licitacaoId,
                tipo: this.tipo,
                nomeRazaoSocial: this.dadosGerais.nomeRazaoSocial,
                email: this.dadosGerais.email,
                telefone: this.dadosGerais.telefone,
                assunto: this.dadosGerais.assunto,
                tipoPessoa: this.dadosGerais.tipoPessoa,
                cpfCnpj: this.dadosGerais.tipoPessoa === 'F' ? this.dadosGerais.cpf : this.dadosGerais.cnpj,
                anexoUpload: this.dadosGerais.anexoUpload,
                repositorioUri: this.dadosGerais.repositorioUri
            }
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Enviando esclarecimento/impugnação...')
            await this.$store.dispatch(actionTypes.INSERIR_ESCLARECIMENTO_IMPUGNACAO_SERVIDOR, payload)
            this.mostrarNotificacaoSucessoDefault()
            this.desabilitarLoadingGlobal()
            this.modalConfirmarEnvio = false
            this.$emit('buscarEsclarecimentoImpugnacoes')
        },
        async validarCampos() {
            return await this.$validator.validateAll()
        },
        fecharModal() {
            this.$emit('fecharModal')
        },
        setarArquivoUpload(arquivoUpload) {
            this.dadosGerais.anexoUpload = arquivoUpload
        },
        removerArquivoUpload() {
            this.dadosGerais.anexoUpload = null
        },
    }
}
</script>

<style lang="stylus">
.modal-title
    margin: 0
    padding: 10px 20px
    font-size: 18px !important
    color: white

.label
    font-size 14px
    font-weight bold
    color #3A6861 !important

.radio-group-esc-imp.v-input--selection-controls
    margin-top 0

</style>
